export default __webpack_public_path__ + "4312d78b73bb519c61860771c4dbcffc.svg";